module.exports = __webpack_public_path__ + "img/contact6.8ebdc78d.png";